import React from "react";
import { Play, Zap, BadgeCheck, Briefcase } from "lucide-react";
import { FONT, SAFE_BOTTOM, glassBox, glassInner, GLASS } from "../kota/ui";
import { fmtDetik } from "./profesi";

// Tombol Mulai besar di dasar layar (ala Thaloria): kiri ikon play + "Mulai", kanan lencana biaya ⚡.
// Varian: belum warga → "Jadi Warga Jawsel"; belum pilih profesi → "Pilih kerja"; energi kurang → nonaktif + hitung mundur.
export function MulaiBar({ mode, biaya, berikut, onClick }) {
  const isi = {
    warga: [BadgeCheck, "Jadi Warga Jawsel", null],
    pilih: [Briefcase, "Pilih kerja dulu", null],
    habis: [Zap, `Energi kurang · +1 dalam ${fmtDetik(berikut || 0)}`, null],
    mulai: [Play, "Mulai", biaya],
  }[mode];
  const [Icon, label, badge] = isi;
  const mati = mode === "habis";
  return (
    <div style={{ position: "absolute", left: 0, right: 0, bottom: 0, display: "flex", justifyContent: "center", padding: `0 14px calc(${SAFE_BOTTOM} + 18px)`, pointerEvents: "none", fontFamily: FONT }}>
      <button data-testid={`kerja-mulai-${mode}`} onClick={onClick} disabled={mati}
        style={{ pointerEvents: "auto", width: "100%", maxWidth: 520, height: 62, borderRadius: 99, display: "flex", alignItems: "center", gap: 12, padding: "0 10px 0 10px", cursor: mati ? "default" : "pointer",
          ...glassBox, background: GLASS.bgStrong, color: mati ? GLASS.sub : GLASS.ink,
          fontFamily: FONT, transition: "transform .12s, background-color .3s", WebkitTapHighlightColor: "transparent" }}
        onPointerDown={e => { if (!mati) e.currentTarget.style.transform = "scale(.98)"; }}
        onPointerUp={e => { e.currentTarget.style.transform = "scale(1)"; }}
        onPointerLeave={e => { e.currentTarget.style.transform = "scale(1)"; }}>
        <span style={{ width: 42, height: 42, borderRadius: 99, background: mati ? GLASS.inner : GLASS.accentBg, color: mati ? GLASS.sub : GLASS.accent, display: "grid", placeItems: "center", flex: "none", border: "1px solid var(--g-border)" }}><Icon size={18} fill={mode === "mulai" ? "currentColor" : "none"} /></span>
        <b style={{ flex: 1, textAlign: "left", fontSize: 16.5, fontWeight: 800, letterSpacing: -0.2 }}>{label}</b>
        {badge != null && <span data-testid="kerja-biaya" style={{ display: "inline-flex", alignItems: "center", gap: 3, height: 36, padding: "0 13px 0 10px", borderRadius: 99, ...glassInner(true), fontSize: 13.5, fontWeight: 800 }}><Zap size={13} fill="#d9a21b" color="#d9a21b" />{badge}</span>}
      </button>
    </div>
  );
}
